// AdminFrontend/src/unicodex_ui/admin/pages/AdminApplicationsPage.jsx
import React, { useEffect, useState } from "react";
import "../styles/Admin.css";
import {
  fetchApplications,
  approveApplication,
  rejectApplication,
} from "../services/adminIdentityApi";

function AdminApplicationsPage({ adminEmail, onLogout }) {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionId, setActionId] = useState(null);
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");

  async function loadApplications() {
    setLoading(true);
    setError("");
    setInfo("");

    try {
      const data = await fetchApplications({ status: "pending" });
      if (!data || data.ok !== true) {
        setError("Failed to load applications.");
        setApplications([]);
        return;
      }
      setApplications(data.applications || []);
    } catch (err) {
      console.error("[AdminApplicationsPage] load error:", err);
      setError("Unable to load applications. Check login or server.");
      setApplications([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadApplications();
  }, []);

  async function handleApprove(id) {
    setActionId(id);
    setError("");
    setInfo("");

    try {
      const data = await approveApplication(id);
      if (!data || data.ok !== true) {
        setError("Failed to approve application.");
        return;
      }
      setInfo(`Application #${id} approved.`);
      await loadApplications();
    } catch (err) {
      console.error("[AdminApplicationsPage] approve error:", err);
      setError("Error approving application. Please try again.");
    } finally {
      setActionId(null);
    }
  }

  async function handleReject(id) {
    setActionId(id);
    setError("");
    setInfo("");

    try {
      const data = await rejectApplication(id);
      if (!data || data.ok !== true) {
        setError("Failed to reject application.");
        return;
      }
      setInfo(`Application #${id} rejected.`);
      await loadApplications();
    } catch (err) {
      console.error("[AdminApplicationsPage] reject error:", err);
      setError("Error rejecting application. Please try again.");
    } finally {
      setActionId(null);
    }
  }

  return (
    <section className="ucx-section">
      <div className="ucx-container ucx-admin-page">
        <div className="ucx-admin-header">
          <div>
            <h1 className="ucx-admin-title">Pending Manufacturer Applications</h1>
            <p className="ucx-admin-subtitle">
              Approve or reject UNI-CODEX prefix applications submitted from the
              public portal.
            </p>
          </div>
          <div className="ucx-admin-header-right">
            {adminEmail && (
              <span className="ucx-small">Signed in as {adminEmail}</span>
            )}
            <button
              type="button"
              className="ucx-admin-btn ucx-admin-btn-reject"
              onClick={onLogout}
            >
              Sign out
            </button>
          </div>
        </div>

        <div className="ucx-admin-status">
          {loading && <span>Loading applications…</span>}
          {!loading && !error && !info && applications.length === 0 && (
            <div className="ucx-admin-empty">
              No pending applications. New submissions will appear here.
            </div>
          )}
          {error && <div className="ucx-admin-status-error">{error}</div>}
          {info && <div className="ucx-admin-status-success">{info}</div>}
        </div>

        {!loading && applications.length > 0 && (
          <div className="ucx-admin-table-wrapper">
            <table className="ucx-admin-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Legal Name</th>
                  <th>Entity Type</th>
                  <th>Country</th>
                  <th>Contact</th>
                  <th>Email</th>
                  <th>Submitted</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {applications.map((app) => (
                  <tr key={app.id}>
                    <td>{app.id}</td>
                    <td>{app.legal_name}</td>
                    <td>{app.entity_type}</td>
                    <td>{app.country}</td>
                    <td>{app.contact_name}</td>
                    <td>{app.contact_email}</td>
                    <td>
                      {app.created_at
                        ? new Date(app.created_at).toLocaleString()
                        : "-"}
                    </td>
                    <td>
                      <div className="ucx-admin-actions">
                        <button
                          type="button"
                          className="ucx-admin-btn ucx-admin-btn-approve"
                          onClick={() => handleApprove(app.id)}
                          disabled={actionId === app.id}
                        >
                          {actionId === app.id ? "Working…" : "Approve"}
                        </button>
                        <button
                          type="button"
                          className="ucx-admin-btn ucx-admin-btn-reject"
                          onClick={() => handleReject(app.id)}
                          disabled={actionId === app.id}
                        >
                          {actionId === app.id ? "Working…" : "Reject"}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
}

export default AdminApplicationsPage;
